/** Pour import dynamique du module. */
export interface IMarkdownParser {
	markdownParse(str: string): string
}

/**
 * Basic Markdown Parser
 * https://gist.github.com/fuzzyfox/5843166
 *
 * This function parses a small subset of the Markdown language as defined by
 * [John Gruber](http://daringfireball.net/projects/markdown). It's very basic
 * and needs to be refactored a little, and there are plans to add more support
 * for the rest of the language in the near future.
 *
 * This implimentation is based loosely on
 * [slimdown.php](https://gist.github.com/jbroadway/2836900) by Johnny Broadway.
 *
 * @version 0.1
 * @author William Duyck <fuzzyfox0@gmail.com>
 * @license http://www.mozilla.org/MPL/2.0/ Mozilla Public License 2.0
 *
 * @param  {String} str A Markdown string to be converted to HTML.
 * @return {String}     The HTML for the given Markdown.
 */
export function markdownParse(str: string): string {
	const arr = str.replace(/</g, '&lt;').split('\n');
	let i = 0;
	let j = arr.length;
	if (j === 1) {
		//inline
		return parse_line(arr[i]);
	}
	//multiLines
	const rtn = [];
	for (; i < j; i++) {
		rtn.push(parse_line("\n" + arr[i].trim() + "\n"));
	}
	let rtnS = rtn.join('\n');
	for (i = 0, j = fixes.length; i < j; i++) {
		rtnS = preg_replace(fixes[i][0], fixes[i][1], rtnS);
	}
	return rtnS;
}


function parse_line(str: string) {
	for (let i = 0, j = rules.length; i < j; i++) {
		const r = rules[i][0];
		const v = rules[i][1];
		if (typeof v == 'function') {
			r.lastIndex = -1;
			const matches = r.exec(str);
			if (matches !== null) {
				if (matches.length > 1) {
					str = preg_replace(r, v(matches[1], matches[2]), str);
				} else {
					str = preg_replace(r, v(matches[0]), str);
				}
			}
		} else {
			str = preg_replace(r, v, str);
		}
	}
	return str.trim();
}

/**
 * preg_replace (from PHP) in JavaScript!
 *
 * This is basically a pattern replace. You can use a regex pattern to search and
 * another for the replace. For more information see the PHP docs on the original
 * function (http://php.net/manual/en/function.preg-replace.php), and for more on
 * JavaScript flavour regex visit http://www.regular-expressions.info/javascript.html
 *
 * NOTE: Unlike the PHP version, this function only deals with string inputs. No arrays.
 *
 * @author  William Duyck <fuzzyfox0@gmail.com>
 * @license http://www.mozilla.org/MPL/2.0/ Mozilla Public License 2.0
 *
 * @param  {String}  pattern  The pattern to search for.
 * @param  {String}  replace  The string to replace.
 * @param  {String}  subject  The string to search and replace.
 * @return  {String}  If matches are found, the new subject will be returned.
 */
function preg_replace(regExp: RegExp, replace: string, subject: string) {
	const i = [];
	let j = 0, k = 0, l = subject, m;
	if (regExp.flags.indexOf("g") >= 0) {
		regExp.lastIndex  = -1;
		do {
			m = regExp.exec(subject);
			if (m === null) break;
			i.push(m);
		} while (true);
	} else {
		m = regExp.exec(subject);
		if (m !== null) i.push(m);
	}

	for (j = i.length - 1; j > -1; j--) {
		for (m = replace, k = i[j].length; k > -1; k--) m = m.replace("${" + k + "}", i[j][k]).replace("$" + k, i[j][k]).replace("\\" + k, i[j][k]);
		l = l.replace(i[j][0], m)
	}
	return l
}

const rules: ([RegExp, string | ((...args: any[]) => string)])[] = [
	// headers
	[/\n(#+)(.*)/g, (chars: string, header: string) => {
		const level = chars.length;
		return '<h' + level + '>' + header.trim() + '</h' + level + '>';
	}],
	// images
	[/!\[([^\[]+)]\(([^(]+)\)/g, '<img src=\"\\2\" alt=\"\\1\" />'],
	// link
	[/\[([^\[]+)]\(([^(]+)\)/g, '<a href=\"\\2\">\\1</a>'],
	// bold
	[/\b(__)(.*?)\1\b/g, '<strong>\\2</strong>'],
	[/(\*\*)(.*?)\1/g, '<strong>\\2</strong>'],
	// emphasis
	[/\b([_])(.*?)\1\b/g, '<em>\\2</em>'],
	[/([*])(.*?)\1/g, '<em>\\2</em>'],
	// strike
	[/\b(~~)(.*?)\1\b/g, '<del>\\2</del>'],
	// quote
	[/:"(.*?)":/g, '<q>\\1</q>'],
	// unordered list
	[/\n[*-](.*)/g, function (item: string) {
		return '<ul>\n<li>' + item.trim() + '</li>\n</ul>';
	}],
	// ordered list
	[/\n[0-9]+\.(.*)/g, function (item: string) {
		return '<ol>\n<li>' + item.trim() + '</li>\n</ol>';
	}],
	// blockquote
	[/\n\\>(.*)/g, function (str: string) {
		return '<blockquote>' + str.trim() + '</blockquote>';
	}],
	// paragraphs
	[/\n[^\n]+\n/g, function (line: string) {
		line = line.trim();
		if (line[0] === '<') {
			return line;
		}
		return '\n<p>' + line + '</p>\n';
	}]
];

const fixes:([RegExp, string])[] = [
	[/<\/ul>\n<ul>/g, '\n'],
	[/<\/ol>\n<ol>/g, '\n'],
	[/<\/blockquote>\n<blockquote>/g, "\n"]
];